module.exports = __webpack_public_path__ + "media/assets/floattingButton-81c73772fec8a8b7814033ff878ec002.png";